import axios from 'axios';
import { PATH, PRODUCT_URL } from '../../Constants';
import * as documentActionType from './documentActionType';
import { toast } from 'react-toastify';
import { redirectToLogin } from '../Common/CommonAction';

var token = sessionStorage.getItem('token');
var admin_email = sessionStorage.getItem('name');

export const getDocumentData = (queueName) => async (dispatch, getState) => {
  const { start, end, total } = getState().common.pagination;
  console.log('getstate', getState());
  // dispatch({
  //   type: documentActionType.DOCUMENT_DATA,
  //   payload: [],
  // });
  const data = {
    admin_email,
  };
  const args = {
    method: 'POST',
    url: `${PRODUCT_URL}${PATH.display_document}`,
    data,
    headers: {
      'Content-type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    // data: {
    //   page_no: 1,
    //   rows_per_page: 10,
    // },
  };

  try {
    let api = await axios(args);
    if (api.status == 200) {
      console.log('check Api', api.data.Documents);
      let data = [];
      api.data.Documents.map((e) => {
        data.push([
          e.name,
          e.queues,
          // e.mapping.hasOwnProperty(queueName) ? 'Yes' : 'No',
          {
            mappings: Object.entries(e.mapping)
              .filter((f) => f[1] === 'Yes')
              .flat()
              .filter((g) => g !== 'Yes'),
          },
          e.fields_count,
          e.id,
          e.fields,
          e.type,
          //e.Total_Documents,
        ]);
      });
      //data.push(api.data.Total_Documents);
      // setDisplayProcessor(data);
      dispatch({
        type: documentActionType.DOCUMENT_DATA,
        payload: data,
      });
      dispatch({
        type: documentActionType.DOCUMENT_DASHBOARD_LENGTH,
        payload: api.data.Total_Documents,
      });

      console.log(api.data.Documents,'checkkkkihk');
    } else {
      toast.error('Something Went Wrong');
      dispatch({
        type: documentActionType.DOCUMENT_DATA,
        payload: [],
      });
    }
  } catch (error) {
    if (error && error.response) {
      dispatch({
        type: documentActionType.DOCUMENT_DATA,
        payload: [],
      });
      if (error.response.status === 401) {
        redirectToLogin();
      }
      return false;
    }
  }
};

export const setDocumentData = (fields) => async (dispatch) => {
  dispatch({
    type: documentActionType.ADD_DOCUMENT,
    payload: fields,
  });
};

export const addDocumentData = (fields) => async (dispatch) => {
  const args = {
    method: 'post',
    url: `${PRODUCT_URL}${PATH.add_document}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    data: { ...fields, admin_email },
  };
  console.log('check add processor,', args);
  try {
    let api = await axios(args);
    if (api.status == 200) {
      toast.success(api?.data?.result?.message);
      return true;
    } else {
      toast.error('Something Went Wrong');
      return false;
    }
    //  console.log(api,"status api")
  } catch (error) {
    if (error && error.response) {
      if (error.response.status === 401) {
        redirectToLogin();
      }
      return false;
    }
  }
};
export const deleteDocuments = (fields) => async (dispatch) => {
  const args = {
    method: 'post',
    url: `${PRODUCT_URL}${PATH.delete_document}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    data: { ...fields, admin_email },
  };
  console.log('check add processor,', args);
  try {
    let api = await axios(args);
    if (api.status == 200) {
      toast.success(api?.data?.message);
      return true;
    } else {
      toast.error('Something Went Wrong');
      return false;
    }
    //  console.log(api,"status api")
  } catch (error) {
    if (error && error.response) {
      if (error.response.status === 401) {
        redirectToLogin();
      }
      return false;
    }
  }
};

export const mapDocumentsAction = (index) => async (dispatch) => {
  const args = {
    method: 'post',
    url: `${PRODUCT_URL}${PATH.map_document}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    data: { ...index, admin_email },
  };
  console.log('check add processor,', args);
  try {
    let api = await axios(args);
    if (api.status === 200) {
      toast.success(api?.data?.message);
      return true;
    } else {
      toast.error('Something Went Wrong');
      return false;
    }
    //  console.log(api,"status api")
  } catch (error) {
    if (error && error.response) {
      if (error.response.status === 401) {
        redirectToLogin();
      }
      return false;
    }
  }
};
// * UNMAP DOCUMENT
export const unMapDocumentsAction = (index) => async (dispatch) => {
  const args = {
    method: 'post',
    url: `${PRODUCT_URL}${PATH.unmap_document}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    data: { ...index, admin_email },
  };
  console.log('check add processor,', args);
  try {
    let api = await axios(args);
    if (api.status === 200) {
      toast.success(api?.data?.message);
      return true;
    } else {
      toast.error('Something Went Wrong');
      return false;
    }
    //  console.log(api,"status api")
  } catch (error) {
    if (error && error.response) {
      if (error.response.status === 401) {
        redirectToLogin();
      }
      return false;
    }
  }
};
// Get fields for document
export const getFieldsForDocument = () => async (dispatch) => {
  const args = {
    method: 'GET',
    url: `${PRODUCT_URL}${PATH.fields_document}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    let api = await axios(args);
    if (api.status == 200) {
      console.log('check Api', api);
      dispatch({
        type: documentActionType.GET_FIELDS_FOR_DOCUMENT,
        payload: api.data,
      });
    } else {
      toast.error('Something Went Wrong');
      dispatch({
        type: documentActionType.GET_FIELDS_FOR_DOCUMENT,
        payload: {},
      });
    }
  } catch (error) {
    if (error && error.response) {
      dispatch({
        type: documentActionType.GET_FIELDS_FOR_DOCUMENT,
        payload: {},
      });
      if (error.response.status === 401) {
        redirectToLogin();
      }
      return false;
    }
  }
};

// * Edit/Update Document
export const updateDocument = (data) => async (dispatch) => {
  const args = {
    method: 'POST',
    url: `${PRODUCT_URL}${PATH.edit_document}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    data: { ...data, admin_email },
  };
  try {
    let api = await axios(args);
    if (api.data.status === 200) {
      toast.success(api?.data?.message);
      return true;
    } else {
      toast.error(api.data.message);
      return false;
    }
    //  console.log(api,"status api")
  } catch (error) {
    if (error && error.response) {
      if (error.response.status === 401) {
        redirectToLogin();
      }
      return false;
    }
  }
};
// setUpdateFieldsForDocument
export const setUpdateFieldsForDocument = (data) => async (dispatch) => {
  dispatch({
    type: documentActionType.SET_UPDATE_FIELDS_FOR_DOCUMENT,
    payload: data,
  });
};
